<svg class="align-middle" xmlns="http://www.w3.org/2000/svg" [attr.width]="size()" [attr.height]="size()" viewBox="0 0 35 24" transform="rotate(90)">
	<g transform="matrix(0.0158514,0,0,0.0193237,0,0)">
		<g transform="matrix(7.01798e-15,-94.0179,100.923,5.06934e-15,-143310,31758)">
			<path d="M328.787,1437.99L328.787,1442.49L324.287,1442.49L324.287,1419.99L328.787,1419.99L328.787,1424.49L333.287,1424.49L333.287,1428.99L337.787,1428.99L337.787,1433.49L333.287,1433.49L333.287,1437.99L328.787,1437.99Z" [attr.fill]="color()"/>
		</g>
	</g>
</svg>

